import { render, staticRenderFns } from "./DeleteSocialNetworkPostDialog.vue?vue&type=template&id=4aab9e26&"
import script from "./DeleteSocialNetworkPostDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteSocialNetworkPostDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports